export function isTwoD(entry) {
    const { info } = entry;
    return info?.dimension === 2;
}
//# sourceMappingURL=isTwoD.js.map